import lax from 'lax.js';

window.lax = lax;

window.addEventListener('load', () => {
  lax.init();

  lax.addDriver('scrollY', () => {
    return window.scrollY;
  }, {
    inertiaEnabled: true,
  });

  // lax.addElements('.lax-image_shift img, .lax-image_shift iframe', {
  //   scrollY: {
  //     translateY: [
  //       ['elInY', 'elOutY'],
  //       [-200, 0]
  //     ]
  //   }
  // });

  // lax.addElements('.lax-mobile_container_shift', {
  //   scrollY: {
  //     transform: [
  //       ['elCenterY', 'elOutY'],
  //       {
  //         980: [20, -90],
  //         981: [0, 0],
  //       },
  //       {
  //         cssFn: (val) => {
  //           return `translateX(${val}%)`;
  //         },
  //       }
  //     ]
  //   }
  // });
});